
import Hub from '../events/hub'

function hasJsonStructure(str) {
    if (typeof str !== 'string') return false;
    try {
        const result = JSON.parse(str);
        return Object.prototype.toString.call(result) === '[object Object]' 
            || Array.isArray(result);
    } catch (err) {
        return false;
    }
}

var MainModule = function (Vue, Router) {
	Vue.prototype.$mainModule = {
		cleanup: function(){
			localStorage.clear();

			Vue.prototype.$mainModule.updateTotal();
		},

		/*unlockStep: function(stepName){
			let unlockedSteps = Vue.prototype.$mainModule.get('unlockedSteps');
			unlockedSteps.push(stepName);

			Vue.prototype.$mainModule.set('unlockedSteps', unlockedSteps);
		},*/

	    set: function(name, value, expireDays) {
	        if (typeof value === 'object') {
	            value = JSON.stringify(value);
	        }
	        if (expireDays == undefined){
	        	expireDays = 1;
	        }

	        localStorage.setItem('eventconf_' + name, value);
	    },

	    get: function(name) {
	        const value = localStorage.getItem('eventconf_' + name);
	        if (hasJsonStructure(value)) {
	            return JSON.parse(value);
	        }

	        return value;
	    },

	    delete: function(name){
	    	localStorage.removeItem('eventconf_' + name);
	    },

	    updateTotal: function(){
	    	let sums = {};
            let subtotal = 0.00;
            let total = 0.00;
            let equipmentTotal = 0.00;
            let cateringTotal = 0.00;

    		let selectedPackage = Vue.prototype.$mainModule.get('package');
    		let participantsNumber = Vue.prototype.$mainModule.get('participantsNumber');
    		let time = Vue.prototype.$mainModule.get('time');

    		let selectedEquipment = Vue.prototype.$mainModule.get('selectedEquipment');
    		let selectedEquipmentQuantities = Vue.prototype.$mainModule.get('selectedEquipmentQuantities');
    		let equipmentRates = Vue.prototype.$mainModule.get('equipmentRates');

    		let selectedCatering = Vue.prototype.$mainModule.get('selectedCatering');
    		let selectedCateringQuantities = Vue.prototype.$mainModule.get('selectedCateringQuantities');
    		let availableCateringOptionsByID = Vue.prototype.$mainModule.get('availableCateringOptionsByID');

    		if (selectedPackage === null){
    			Vue.prototype.$mainModule.set('sums', {
    				subtotal: 0.00,
		    		equipmentTotal: 0.00,
		    		cateringTotal: 0.00,
		    		total: 0.00,
		    		totalPerParticipant: 0.00
    			});
    			return;
    		}

    		subtotal = Number(selectedPackage.ProductPackage.price) * participantsNumber;

    		// sum selected equipment
    		// FIXME: Doesn't handle price_type well.
    		if (selectedEquipment){
    			selectedEquipment.forEach(function(itemID){
    				// only equipment that has assigend rates; the other are inclusive
    				if (itemID in equipmentRates){
    					switch (equipmentRates[itemID].price_type){
    						case 'item': // price per item
    							equipmentTotal += equipmentRates[itemID].price * 
	    							selectedEquipmentQuantities[itemID];
    						break;

    						case 'fixed': // one-off charge
    							equipmentTotal += Number(equipmentRates[itemID].price);
    						break;

    						case 'hour': // price per hour
    							let timeStart = new Date('01/01/2007 ' + time[0]).getHours();
								let timeEnd = new Date('01/01/2007 ' + time[1]).getHours();
								let hourDiff = timeEnd - timeStart;

								equipmentTotal += equipmentRates[itemID].price * hourDiff;
    						break;
    					}
    				}
    			}.bind(this));
    		}

    		// sum selected catering options
    		if (selectedCatering){
    			selectedCatering.forEach(function(itemID){
	    			cateringTotal += availableCateringOptionsByID[itemID].price * selectedCateringQuantities[itemID];
	    		}.bind(this));
    		}

    		total = subtotal + equipmentTotal + cateringTotal;

    		sums = {
	    		subtotal: subtotal,
	    		equipmentTotal: equipmentTotal,
	    		cateringTotal: cateringTotal,
	    		total: total,
	    		totalPerParticipant: total / participantsNumber
	    	};

	    	Vue.prototype.$mainModule.set('sums', sums);

	    	return sums;
	    },

	    /*savePurchase: function(model) {
	        return new Promise(function(resolve, reject) {
	            let locationID = Vue.prototype.$mainModule.get('location').id;
	            let userData = Vue.prototype.$mainModule.get('userData');
	            let contactPersonData = Vue.prototype.$mainModule.get('contactPersonData');
	            let separateInvoiceData = Vue.prototype.$mainModule.get('separateInvoiceData');
	            let separateShippingData = Vue.prototype.$mainModule.get('separateShippingData');
	            let purchaseData = Vue.prototype.$mainModule.get('purchaseData');
	            let affiliateKey = Vue.prototype.$mainModule.get('affiliateKey');
	            let additionalAddresses = [];
	            let endpoint = '';
	            let requestData = {};

	            // fix format of v-selects
	            userData.customer_type = userData.customer_type.value;
				userData.salutation = userData.salutation.value;
				userData.driver_salutation = userData.driver_salutation.value;

				if (userData.country_id != null){
					userData.country_id = userData.country_id.value;
				}

				userData.is_company = (userData.customer_type == 'company');

				if (contactPersonData){
					contactPersonData.salutation = contactPersonData.salutation.value;
					additionalAddresses.push(contactPersonData);
				}

				if (separateInvoiceData){
					separateInvoiceData.country_id = separateInvoiceData.country_id.value;
					additionalAddresses.push(separateInvoiceData);
				}

				if (separateShippingData){
					separateShippingData.country_id = separateShippingData.country_id.value;
					additionalAddresses.push(separateShippingData);
				}

				if (model == 'Booking'){
					endpoint = Vue.prototype.$apiBase + 'bookings/save.json?lang=' + Vue.config.language + '&location_id=' + locationID;
					requestData = {
		                User: userData,
		                UserAdditionalAddress: additionalAddresses,
		                Booking: {
		                    timeslot_id: Vue.prototype.$mainModule.get('timeslot').id,
		                    payment_method_id: Vue.prototype.$mainModule.get('paymentMethodID'),
		                    reserved_items: Vue.prototype.$mainModule.get('itemIDs'),
		                    payment_adv_rate: Vue.prototype.$mainModule.get('paymentAdvRate'),
		                    participants_number: Vue.prototype.$mainModule.get('participantsNumber'),
		                    insurance_id: Vue.prototype.$mainModule.get('insuranceID'),
		                    transaction_reference: Vue.prototype.$mainModule.get('transactionReference'),
		                    affiliate_key: affiliateKey
		                },
		                CouponCode: Vue.prototype.$mainModule.get('validatedVoucherCodes')
		            };

		            if (purchaseData){
		            	if ('foreign_key' in purchaseData){
		            		requestData.Booking.id = purchaseData.foreign_key;
		            	}
		            }
				}
				else{
					endpoint = Vue.prototype.$apiBase + 'orders/save.json?lang=' + Vue.config.language + '&location_id=' + locationID;
					requestData = {
		                User: userData,
		                Order: {
		                    payment_method_id: Vue.prototype.$mainModule.get('paymentMethodID'),
                            shipping_type: Vue.prototype.$mainModule.get('shipping'),
                            transaction_reference: Vue.prototype.$mainModule.get('transactionReference'),
                            affiliate_key: affiliateKey
		                },
		                OrderItem: [
		                	{
		                		foreign_key: Vue.prototype.$mainModule.get('voucherFormat').id,
                                model: 'CouponFormat',
                                quantity: Vue.prototype.$mainModule.get('voucherQuantity')
		                	}
		                ]
		            };

		            requestData.User.UserAdditionalAddress = additionalAddresses;

		            if (purchaseData){
		            	if ('foreign_key' in purchaseData){
		            		requestData.Order.id = purchaseData.foreign_key;
		            	}
		            }
				}

	            Vue.http.post(endpoint, requestData)
	            .then(function(response) {
	                resolve(response);
	            });
	        });
	    }*/
	};
}

export default MainModule